function filterOffers() {

	var loadTimeout = null,
		htmlString = '<div class="loader"><div class="logo-text-hld"><img class="logo-text" src="/img/logo-text.png"></div></div>',
		$listingItems = document.querySelector('.listing--items'),
		$filter = document.querySelectorAll('.filter');

	for (var i = 0; i < $filter.length; i++) {
		$filter[i].addEventListener('click', function(e){

			var tag = this.getAttribute('data-value'),
				params = 'Category='+tag;

			$('.no-items').removeClass('active');

			$('.listing--items').append(htmlString);

			$('.filter').removeClass('active');

			$(this).addClass('active');

			$('.listing--items').addClass('loading');

			$('.filter.active').each(function(i, el){
				tags = $(el).data('value');
			});

			// use timeout to delay ajax for multiple clicks
			if (loadTimeout != null) clearTimeout(loadTimeout);

			loadTimeout = setTimeout(function(){

				$('.listing--items').load('? .listing--items > *', params, function(){

					$(this).removeClass('loading');

					$('.listing-item').removeClass('active');

					$('.listing-item').addClass('show');

					if(!$('.listing-item').length){
	                	$('.no-items').addClass('active');
	                }

				});

				loadTimeout = null;

			}, 300);

		});
	}
	
};

module.exports = filterOffers;